import { Search } from "lucide-react";
import type { FC } from "react";

import { MetaLine } from "@/components/ui/meta-line";
import { RESEARCH_SOURCES } from "@/features/research";

/** Under a user message: the library sources the attorney asked to research. */
export const ResearchSourcesLine: FC<{ sources: readonly string[] }> = ({
  sources
}) => {
  const labels = RESEARCH_SOURCES.filter((s) => sources.includes(s.id)).map(
    (s) => s.label
  );
  if (!labels.length) return null;
  return (
    <MetaLine
      data-testid="turn-research-sources"
      className="px-1"
      parts={[
        <span key="sources" className="inline-flex min-w-0 items-center gap-1">
          <Search className="size-3 shrink-0" />
          <span className="min-w-0 truncate">
            Researched in {labels.join(", ")}
          </span>
        </span>
      ]}
    />
  );
};
